import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import ErrorPage from 'next/error';

import { EnterpriseSignup } from 'src/enterprise/signup';
import { EnterpriseLayout } from 'src/components/layouts/enterprise-layout';
import { PageComponent } from 'src/types';

const EnterpriseLoyaltySignupPage: PageComponent = () => {
  const flags = useFlags();

  const isEnterpriseSignupEnabled = flags['consumer.ecomm.enterprise-loyalty-signup.rollout'] ?? true;

  if (!isEnterpriseSignupEnabled) {
    return <ErrorPage statusCode={404} />;
  }

  return <EnterpriseSignup />;
};

EnterpriseLoyaltySignupPage.layout = EnterpriseLayout;

export default EnterpriseLoyaltySignupPage;
